import React from 'react';
import { Box, Button } from '@mui/material';
import { useSystemsContext } from '../../context/SystemsContext';

const SystemActionButtons: React.FC = () => {
  // Pull all necessary state and handlers from the context
  const {
    isLoadingSystem,
    selectedSection,
    selectedConfig: expandedConfigId,
    dirty,
    canSave,
    saveChanges,
    cancelCreateSystem,
    deleteConfig,
    duplicateConfig,
    deleteSystem
  } = useSystemsContext();

  // Don't render any buttons while the main system data is loading
  if (isLoadingSystem) {
    return null;
  }

  // Determine if a config section is currently selected
  const isServiceDefinitions = selectedSection === "serviceDefinitions";
  const isConfigSectionSelected =
    !!expandedConfigId &&
    selectedSection !== "systemInfo" &&
    selectedSection !== "createSystem" &&
    !isServiceDefinitions;

  if (isServiceDefinitions) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 4,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      {/* Left-aligned buttons (Destructive or Secondary Actions) */}
      <Box sx={{ display: 'flex', gap: 2 }}>
        {selectedSection === 'createSystem' && (
          <Button
            data-cy="system-cancel-btn"
            variant="outlined"
            color="secondary"
            onClick={cancelCreateSystem}
          >
            Cancel
          </Button>
        )}

        {selectedSection === 'systemInfo' && (
          <Button
            data-cy="system-delete-system-btn"
            variant="outlined"
            color="error"
            onClick={deleteSystem}
          >
            Delete System
          </Button>
        )}

        {isConfigSectionSelected && (
          <>
            <Button data-cy="system-delete-config-btn" variant="outlined" color="error" onClick={deleteConfig}>
              Delete Config
            </Button>
            <Button data-cy="system-duplicate-config-btn" variant="outlined" color="secondary" onClick={duplicateConfig}>
              Duplicate Config
            </Button>
          </>
        )}
      </Box>

      {/* Right-aligned buttons (Primary Actions) */}
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          data-cy="system-save-btn"
          variant="contained"
          color="primary"
          onClick={saveChanges}
          disabled={!canSave}
        >
          {selectedSection === 'createSystem'
            ? 'Create System'
            : dirty
              ? 'Save Changes'
              : 'No Changes'}
        </Button>
      </Box>
    </Box>
  );
};

export default SystemActionButtons;
